// 1: készpénz (Ft),
// 2: bankkártya,
// 3: csekk,
// 4: utalvány,
// 5: Euró,
// 14: Erzsébet utalvány,
// 15: SZÉP kártya,
// 16: ajándékutalvány,
// 17: hűségkártya,
// 18: smart kártya,
// 19: göngyölegjegy,
// 20: kupon

const paymentTypeSam4s = {
  cash: 1,
  bankCard: 2,
  voucher: 4,
  cashEuro: 5,
  vip: 17
}

function sam4sSale(fiscalReceipt) {
  if(!order && !payment) return { success: false, message: 'No order or payment' }
  let res = {}
  res.paymentsTotal = fiscalReceipt.paymentsTotal
  let code = `PTG|1`
  for (let item of fiscalReceipt.items) {
    code += `${String.fromCharCode(92)}1|${item.name}||${item.discountPrice}|${item.count}|db|${item.count * item.discountPrice}|${item.vatLetter}${(item.vatRegister+'').padStart(2, '0')}||`
  }
  for (let payment of fiscalReceipt.payments) {
    code += `${String.fromCharCode(92)}6|${paymentTypeSam4s[payment.agentType] || 2}|${payment?.amount || '0'}`
  }
  res.codes = [code]
  return res
}

function sam4sSaleMachine(order) {
  let res = sam4sSale(order)
  for (let code of res.codes) {
    code = code + String.fromCharCode(13)
  }
  return res
}

// 1 – ügyfél elállása (customer wants)
// 2 – kezelői hiba: téves bevitel (operator mistake)
// 3 – kezelői hiba: téves fizetőeszköz bevitel  (operator mistake, wrong payment type chosen)
// 4 – kezelői hiba: termék nincs készleten  (operator mistake, item not on stock)
// 5 – technikai: téves bizonylattípus kibocsátása (technical mistake, wrong receipt type)
// 6 – technikai: sikertelen fizetőeszköz használat  (technical mistak, unsuccessful payment type used)
// 7 – technikai: téves ügyfél adat/hibás bevitel (technical mistake, wrong user data)
// 8 – technikai: próbavásárlás (technical, practice sales only)
// 0 – egyéb  (other)

// function fiscatAeeStornoV5(reasonCode, receiptNumber, custTaxNumber = '', custName = '', custPostCode = '', custTow = '', custAddress = '') {
//   let code = `http://www.fiscat.com/AEE|STORNO||${receiptNumber || ''}|${reasonCode || ''}|${custTaxNumber}|${custName}|${custPostCode}|${custTow}|${custAddress}|`
//   return {code}
// }

// 01 - váltópénz bevitel  (enter change)
// 02 - pénztáros pénzfelvétel
// 03 - díjbeszedés (fee collection)
// 04 - sorsjegy eladás (lottery ticket sales)
// 05 - előleg (deposit)
// 06 - pénztárhiány (cash shortage)
// 07 - borravaló  (tip)
// 08 - egyéb befizetés  (other)

function sam4sPayIn(reasonCode, paymentAmount, paymentType = 'cash') {
  let code = `PTG|0${String.fromCharCode(92)}9|0|${paymentTypeSam4s[paymentType] || 2}|${reasonCode}|${paymentAmount}`
  return {code}
}

function sam4sPayInMachine(reasonCode, paymentAmount, paymentType = 'cash') {
  let res = sam4sPayIn(reasonCode, paymentAmount, paymentType)
  res.code = res.code + String.fromCharCode(13)
  return res
}
// 1 - fölözés (skim)
// 2 - pénztáros levétel (pay out to cashier)
// 3 - utalvány kivét (pay out cheq)
// 4 - ajándékkártya kivét (gift card pay out)
// 5 - bérkifizetés (sallary pay out)
// 6 - munkabér előleg (salles deposit)
// 7 - postaköltség (post cost)
// 8 - egyéb rezsi (other fee)
// 9 - áruvásárlás (buy goods)
// 10 - záróösszeg levétel (total pay out)
// 11 - egyéb kifizetés (other pay out)

function sam4sPayOut(reasonCode, paymentAmount, paymentType = 'cash') {
  let code = `PTG|1${String.fromCharCode(92)}9|1|${paymentTypeSam4s[paymentType] || 2}|${reasonCode}|${paymentAmount}`
  return {code}
}

function sam4sPayOutMachine(reasonCode, paymentAmount, paymentType = 'cash') {
  let res = sam4sPayOut(reasonCode, paymentAmount, paymentType)
  res.code = res.code + String.fromCharCode(13)
  return res
}

export {
  sam4sSale,
  sam4sPayIn,
  sam4sPayOut,
  sam4sSaleMachine,
  sam4sPayInMachine,
  sam4sPayOutMachine
}
